module.exports = __webpack_public_path__ + "static/img/bannerBg2_en.e642e0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bannerBg2_en.png
// module id = 9mpP
// module chunks = 1